import axios, { AxiosResponse } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { getCreatorApiUrl } from '@client/components/api-urls';
import auth from '@client/components/auth';
import { formatISODate } from '@client/helpers/date-utils';

const fetchTransactions = async (creatorId: number, date: Date) => {
  const creatorApiUrl = new URL(getCreatorApiUrl(`/transaction-ledger/export`));

  const response = await axios.get(creatorApiUrl.toString(), {
    params: {
      date: formatISODate(date),
      creatorId,
    },
    headers: {
      Authorization: auth.getToken(),
    },
  });

  return response;
};

const exportToCsv = (response: AxiosResponse) => {
  const blob = new Blob([response.data], {
    type: response.headers['content-type']?.toString(),
  });
  const a = document.createElement('a');
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  const contentDisposition: string = response.headers['content-disposition'];
  const fileName = contentDisposition
    ?.split('filename=')[1]
    .replace(/['"]/g, '')
    .trim();
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);

  return fileName;
};

export const useTransactionLedger = () => {
  const [isExporting, setIsExporting] = useState(false);

  const exportTransactions = async (creatorId: number, date: Date) => {
    try {
      setIsExporting(true);
      const result = await fetchTransactions(creatorId, date);
      const fileName = exportToCsv(result);
      toast.success(`Exported ${fileName} file`);
    } catch {
      toast.error('Could not export transactions. Try again later.');
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportTransactions,
    isExporting,
  };
};
